const sliders = document.getElementsByClassName('carousel-single__container ');

for (var i = 0; i < sliders.length; i++) {
    sliders[i].navAnchors = sliders[i].querySelectorAll('.carousel-single__slider--nav--links');
    sliders[i].leftArrow = sliders[i].querySelectorAll('.carousel-single__arrow--left')[0];
    sliders[i].rightArrow = sliders[i].querySelectorAll('.carousel-single__arrow--right')[0];
    sliders[i].currentIndex = 0;

    sliders[i].navAnchors.forEach(anchor => {
        anchor.slider = sliders[i];

        anchor.addEventListener('click', (event) => {
            event.preventDefault();
            anchor.slider.currentIndex = Array.from(anchor.slider.navAnchors).indexOf(anchor);
            highlightNavAnchor(event.currentTarget.slider, event.currentTarget.getAttribute('data-slide-index'));
            scrollToSlide(anchor.slider.currentIndex, event.currentTarget.slider);
        });
    });

    sliders[i].leftArrow.slider = sliders[i];

    sliders[i].leftArrow.addEventListener('click', (event) => {
        event.preventDefault();
        prevSlide(event.currentTarget.slider);
    });

    sliders[i].rightArrow.slider = sliders[i];

    sliders[i].rightArrow.addEventListener('click', (event) => {
        event.preventDefault();
        nextSlide(event.currentTarget.slider);
    });

    scrollToSlide(sliders[i].currentIndex, sliders[i]);
}

for (var i = 0; i < sliders.length; i++) {
    sliders[i].querySelectorAll('.carousel-single__container--link').forEach(slide => {
        slide.addEventListener('mouseover', function () {
            this.classList.add('hovered');
        });

        slide.addEventListener('mouseout', function () {
            this.classList.remove('hovered');
        });
    });
}

function highlightNavAnchor(slider, index) {
    slider.navAnchors.forEach(anchor => {
        anchor.classList.remove('carousel-single__slide--active');
    });

    slider.navAnchors[index].classList.add('carousel-single__slide--active');
}

function prevSlide(slider) {
    slider.currentIndex = (slider.currentIndex - 1 + slider.navAnchors.length) % slider.navAnchors.length;
    scrollToSlide(slider.currentIndex, slider);
}

function nextSlide(slider) {
    slider.currentIndex = (slider.currentIndex + 1) % slider.navAnchors.length;
    scrollToSlide(slider.currentIndex, slider);
}

function scrollToSlide(index, carousel) {
    var sliderId = carousel.getAttribute('data-id');
    const targetSlide = document.getElementById(`${sliderId}-slide-${index + 1}`);

    var slider = carousel.getElementsByClassName('carousel-single__slider')[0];

    slider.scrollTo({
        left: targetSlide.offsetLeft,
        behavior: 'smooth'
    });

    generateMobileText(carousel, targetSlide);
    highlightNavAnchor(carousel, carousel.currentIndex);
}

function generateMobileText(carousel, targetSlide) {
    var carouselId = carousel.getAttribute('data-id');
    var text = targetSlide.querySelector('.carousel-single__slide--text-innertext');
    var mobileTextContainerFromDOM = carousel.querySelector('.carousel-single-mobile-text--container');

    if (text) {
        var actualTextDiv = document.createElement('div');
        actualTextDiv.classList.add('carousel-single-mobile-text--text');
        actualTextDiv.textContent = text.innerHTML;

        var iconDiv = document.createElement('div');
        iconDiv.classList.add('carousel-single-mobile-text--icon');
        iconDiv.innerHTML = `<i class="material-icons" aria-hidden="true">keyboard_arrow_right</i>`;

        var mobileTextMiniContainer = document.createElement('div');
        mobileTextMiniContainer.classList.add('carousel-single-mobile-text--mini-container');

        mobileTextMiniContainer.appendChild(actualTextDiv);

        var link = targetSlide.querySelector('a');

        var htmlToAppend = "";

        if (link) {
            var mobileAnchorTag = document.createElement('a');
            mobileAnchorTag.setAttribute('href', link.getAttribute('href'));
            mobileAnchorTag.classList.add('carousel-single-mobile-link');
            mobileAnchorTag.setAttribute('id', 'carousel-mobile-text-' + carouselId);

            mobileTextMiniContainer.classList.add('arrow');

            mobileAnchorTag.appendChild(mobileTextMiniContainer);
            htmlToAppend = mobileAnchorTag.outerHTML;
        } else {
            mobileTextMiniContainer.appendChild(actualTextDiv);
            htmlToAppend = mobileTextMiniContainer.outerHTML;
        }

        mobileTextContainerFromDOM.classList.remove('carousel-single-mobile-text--container--notext');
        mobileTextContainerFromDOM.innerHTML = htmlToAppend;
    } else {
        mobileTextContainerFromDOM.classList.add('carousel-single-mobile-text--container--notext');
        mobileTextContainerFromDOM.innerHTML = "";
    }

    /* The resulting HTML should look like this:
        <div class="carousel-mobile-text--container">---------------------------------------//mobileTextContainerFromDOM
            <a href="/" class="carousel-mobile-link" id="carousel-mobile-text-@Model.Id">---//mobileAnchorTag
                <div class="carousel__slide--text">-----------------------------------------//mobileTextMiniContainer
                    <div id="carousel__slide--text-@Model.Id">------------------------------//actualTextDiv
                    </div>
                    <div class="carousel-mobile-text--icon">--------------------------------//iconDiv
                        <i class="material-icons" aria-hidden="true">keyboard_arrow_right</i>
                    </div>
                </div>
            </a>
        </div>`
    */
}




// WEBPACK FOOTER //
// ./Components/Blocks/CarouselBlockSingle/carouselSingle.js